import React from "react";
import { connect } from "react-redux";
import { Link, withRouter } from "react-router-dom";
import * as Middleware from "@middlewares/index";

interface PropsInterface {
  location: any;
  Store: any;
  Dispatch: any;
}

interface StateInterface {
  login: string;
  firstname: string;
  lastname: string;
  country: number;
  city: number;
  company: number;
  position: string;
  phone: string;
}

class Default extends React.Component<PropsInterface, StateInterface> {
  public constructor(props: PropsInterface) {
    super(props);
    this.state = {
      login: "",
      firstname: "",
      lastname: "",
      country: 0,
      city: 0,
      company: 0,
      position: "",
      phone: "",
    };
    this.onSubmitHandler = this.onSubmitHandler.bind(this);
    this.onChangeHandler = this.onChangeHandler.bind(this);
  }

  private onSubmitHandler(event: React.FormEvent<HTMLFormElement>): void {
    event.preventDefault();
    this.props.Dispatch(
      Middleware.Auth.update(this.props.Store.Auth.data.id, this.state, () => {
        this.props.Dispatch(Middleware.Ui.Modal.close());
      })
    );
  }

  private onChangeHandler(event: React.ChangeEvent<HTMLInputElement | HTMLSelectElement>): void {
    this.setState({ [event.target.name]: event.target.value });
  }

  public render() {
    return (
      <>
        <div className="modal-background">
          <div className="modal">
            <div className="page-signup">
              <div className="inner">
                <h1>
                  ЗАВЕРШИТЕ РЕГИСТРАЦИЮ (debug(frame: {this.props.Store.Ui.Modal.length})){" "}
                  <button
                    onClick={() => {
                      this.props.Dispatch(Middleware.Ui.Modal.close());
                    }}
                  >
                    x
                  </button>
                </h1>
                <form onSubmit={this.onSubmitHandler}>
                  <div className="row ai-center">
                    <label htmlFor="login">Email *</label>
                    <input
                      type="email"
                      name="login"
                      id="login"
                      value={this.state.login}
                      onChange={this.onChangeHandler}
                      placeholder="login"
                      required={true}
                    />
                  </div>
                  <div className="row ai-center">
                    <label htmlFor="firstname">Имя *</label>
                    <input
                      type="text"
                      name="firstname"
                      id="firstname"
                      value={this.state.firstname}
                      onChange={this.onChangeHandler}
                      placeholder="Имя"
                      // required={true}
                    />
                  </div>
                  <div className="row ai-center">
                    <label htmlFor="lastname">Фамилия *</label>
                    <input
                      type="text"
                      name="lastname"
                      id="lastname"
                      value={this.state.lastname}
                      onChange={this.onChangeHandler}
                      placeholder="Фамилия"
                      // required={true}
                    />
                  </div>

                  <div className="row ai-center">
                    <label htmlFor="country">Страна *</label>
                    <select name="country" id="country">
                      <option value="1">Россия</option>
                      <option value="2">Великобритания</option>
                      <option value="3">Франция</option>
                      <option value="4">США</option>
                    </select>
                  </div>

                  <div className="row ai-center">
                    <label htmlFor="city">Город *</label>
                    <input
                      type="text"
                      name="city"
                      id="city"
                      value={this.state.city}
                      onChange={this.onChangeHandler}
                      placeholder="Город"
                      // required={true}
                    />
                  </div>

                  <div className="row ai-center">
                    <label htmlFor="company">Компания *</label>
                    <input
                      type="text"
                      name="company"
                      id="company"
                      value={this.state.company}
                      onChange={this.onChangeHandler}
                      placeholder="Компания"
                      // required={true}
                    />
                  </div>

                  <div className="row ai-center">
                    <label htmlFor="companytype">Тип компании *</label>
                    <select
                      name="companytype"
                      id="companytype"
                      value={this.state.company}
                      placeholder="Выберите из списка"
                      onChange={this.onChangeHandler}
                      // required={true}
                    >
                      <option value="1">Компания 1</option>
                      <option value="2">Компания 2</option>
                      <option value="3">Компания 3</option>
                      <option value="4">Компания 4</option>
                    </select>
                  </div>

                  <div className="row ai-center">
                    <label htmlFor="position">Ваша должность *</label>
                    <input
                      type="text"
                      name="position"
                      id="position"
                      value={this.state.position}
                      onChange={this.onChangeHandler}
                      placeholder="Ваша должность"
                      // required={true}
                    />
                  </div>

                  <div className="row ai-center">
                    <label htmlFor="phone">Ваш телефон</label>
                    <input
                      type="text"
                      name="phone"
                      id="phone"
                      value={this.state.phone}
                      onChange={this.onChangeHandler}
                      placeholder="Телефон"
                      // required={true}
                    />
                  </div>

                  <div className="privacy">
                    <label htmlFor="privacy">
                      * Согласие с <Link to="#">политикой обработки персональных данных</Link>
                    </label>
                    <input type="checkbox" id="privacy" />
                  </div>

                  <div className="row">
                    <button type="submit" className="btn-blue-white">
                      РЕГИСТРАЦИЯ
                    </button>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </>
    );
  }
}

export default withRouter(
  connect(
    (Store: any) => {
      return { Store };
    },
    (Dispatch: any) => {
      return { Dispatch: (action: any) => Dispatch(action) };
    }
  )(Default)
);
